module.exports = __webpack_public_path__ + "img/cloud.e7ee330.svg";